package com.tovtalk.domain.entity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * App config from GET /api/v1/app/config (version requirements, store URLs).
 * Used to show "update required" when client version < min for platform.
 */
@Serializable
data class AppConfig(
    @SerialName("min_version_android") val minVersionAndroid: Int? = null,
    @SerialName("min_version_ios") val minVersionIos: Int? = null,
    @SerialName("min_version_web") val minVersionWeb: Int? = null,
    @SerialName("store_url_android") val storeUrlAndroid: String? = null,
    @SerialName("store_url_ios") val storeUrlIos: String? = null,
    @SerialName("web_update_instructions") val webUpdateInstructions: String? = null,
    @SerialName("reel_expiration_hours") val reelExpirationHours: Int? = null,
    @SerialName("story_expiration_hours") val storyExpirationHours: Int? = null,
    /** Domains where App Links are verified (assetlinks.json / apple-app-site-association). e.g. ["tovtalk.com"] */
    @SerialName("app_link_domains") val appLinkDomains: List<String>? = null,
    @SerialName("username_change_cooldown_days") val usernameChangeCooldownDays: Int? = null,
    @SerialName("ads_every_n_posts") val adsEveryNPosts: Int = 5,
    @SerialName("profile_ads_every_n_items") val profileAdsEveryNItems: Int = 9,
    @SerialName("feed_ads_enabled_for_guests") val feedAdsEnabledForGuests: Boolean = true,
    @SerialName("profile_ads_enabled_for_guests") val profileAdsEnabledForGuests: Boolean = true,
    @SerialName("guest_reactions_icon_visible") val guestReactionsIconVisible: Boolean = false,
)
